






















import { Component, Prop } from "vue-property-decorator";
import UserBlock from "../../common/user/UserBlock.vue";
import UserInfoPopup from "../user-info-popup/UserInfoPopup.vue";
import UsersListItemBase from "@share/common/users-list/UsersListItemBase";

@Component({
    components: { UserBlock, UserInfoPopup }
})
export default class UsersListItem extends UsersListItemBase {
    @Prop({required: true}) speaker: any;
    @Prop({default: 32}) userIconSize: number;
    @Prop({default: ''}) speakerClassName: string;
    @Prop({ default: false }) hideInfo: boolean;
}
